import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ItemWithImage2 } from '../../components/imageLink/ItemWIthImage';
import { rtTechnology } from '../../config/technology';
import { progressImageConfig } from '../progress/nav/progressImageConfig';
import '../progress/Progress.css';



export function RtProgressNav(props: { username: string }) {
    // const { spec } = useParams<{ spec: string }>();
    const spec = 'seismic';
    const jsxs: JSX.Element[] = []

    const specActive: { [key: string]: string } = (rtTechnology as any)[spec];

    for (let key in specActive) {
        const isActive = window.location.pathname.includes(key);

        jsxs.push(
            <div
                style={{
                    // 布局：每个项独立容器，居中对齐
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 15px', // 项之间的间距
                    color: '#424242',
                    fontSize: 16,
                    fontWeight: 600,
                }}>
                <div style={{
                    width: 140, // 图片容器宽度（图二更小）
                    height: 140, // 图片容器高度
                    borderRadius: '50%', // 圆形（图二是圆形容器）
                    background: '#f6f6f6', // 容器背景色（图二为白色）
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)', // 轻微阴影（图二质感）
                    border: isActive ? '2px solid #40a9ff' : 'none', // 激活项加边框（可选）
                    marginBottom: 10
                }}>
                    <ItemWithImage2
                        src={(progressImageConfig as any)[spec][key]}
                        to={`/${props.username}/rtprogress/${spec}/${key}`}
                        key={key}
                    >

                    </ItemWithImage2>
                </div>
                <FormattedMessage id={key} description={key} defaultMessage={key} />
            </div>
        )
    }
    return (
        <>
            <div style={{
                width: '100%',
                // height: '90%',
                background: '#fff',
                padding: '20px', // 内边距调整
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                borderRadius: '8px',
                position: 'relative',
                zIndex: '1',
            }}>
                <div
                    style={{
                        display: 'flex',
                        flexWrap: 'wrap', // 超出换行
                        alignItems: 'center',
                        gap: '50px', // 项之间的间距
                        paddingLeft: 60,
                        // paddingRight: 90
                    }}
                >
                    {jsxs}
                </div>
            </div>
        </>

    )
}